<template>
  <v-app-bar app color="#F6F5F5" absolute>
    <div class="d-flex align-center">
      <h2 class="mr-1">{{ title }}</h2>
      <h3
        v-if="globalConfig.businessName && fileResultsPath()"
        class="primary--text"
      >
        / [{{ globalConfig.businessName }}] &nbsp;
      </h3>
      &nbsp;
      <h3
        v-if="globalConfig.taskName && fileResultsPath()"
        class="primary--text"
      >
        &nbsp; -
        {{ globalConfig.taskName }}
      </h3>
    </div>

    <v-spacer></v-spacer>
    <v-scroll-x-transition>
      <v-chip
        outlined
        v-if="globalConfig.notLatestVersion && fileResultsPath()"
        color="error"
      >
        <v-icon class="mr-2" color="error">mdi-alert</v-icon>
        <span class="error--text">You are using not latest version now.</span>
      </v-chip>
      <v-chip
        outlined
        v-if="
          globalConfig.oldLastRun &&
          !globalConfig.notLatestVersion &&
          fileResultsPath()
        "
        color="warning"
      >
        <v-icon class="mr-2" color="warning">mdi-clock-alert-outline</v-icon>
        <span class="warning--text">
          The last run of this task was more than 30 days ago.
        </span>
      </v-chip>
    </v-scroll-x-transition>
  </v-app-bar>
</template>

<script>
import { GlobalConfig } from '@/shared/GlobalAppconfig.class';

export default {
  name: 'AppHeader',

  data: () => ({
    globalConfig: GlobalConfig.config
  }),
  computed: {
    title() {
      return (
        'Rhapsody price matcher' +
        (this.$store.getters.isMatcherApiV2Enabled ? ' (V2)' : '')
      );
    }
  },
  methods: {
    fileResultsPath() {
      return /processing-results/gi.test(this.$route.fullPath);
    }
  }
};
</script>
